export const PAYMENT_PROCESSORS = {
  AUTHORIZE: '1',
  BRAINTREE: '2',
  STRIPE: '3',
  BALANCED: '4',
};

export const VERIFIED_STATUS = 'verified';
